// PRNT-4313: the placeholder/loader gating for an unpublished event guest site.
//
// Token-bearing visitors must wait for GetMe to resolve before deciding whether
// to render the "Site Under Construction" placeholder; otherwise admins would
// see it flash briefly before their identity is known.

import type { DeriveUnpublishedSiteGateInput, DeriveUnpublishedSiteGateResult } from './GuestSite.types';

export const deriveUnpublishedSiteGate = (input: DeriveUnpublishedSiteGateInput): DeriveUnpublishedSiteGateResult => {
  const { hasIdentifiedUserOnce, hadTokenAtMount, isAdmin, isGuestSiteSsrEnabled, isPreviewing, isWebsitePublishCapabilityEnabled, isWebsitePublished } = input;

  // Only gate when capability is on, not previewing, and the site is unpublished.
  const isUnpublishedGateActive = !isPreviewing && isWebsitePublishCapabilityEnabled && !isWebsitePublished;

  // Anonymous SSR visitor (no token) can decide immediately. Token-bearing
  // visitors must wait for hasIdentifiedUserOnce so isAdmin is decisive.
  const authResolvedForUnpublishedGate = hasIdentifiedUserOnce || (isGuestSiteSsrEnabled && !hadTokenAtMount);

  const showUnpublishedPage = authResolvedForUnpublishedGate && isUnpublishedGateActive && !isAdmin;
  const suppressGuestSiteUntilAuth = isUnpublishedGateActive && hadTokenAtMount && !hasIdentifiedUserOnce;

  return { showUnpublishedPage, suppressGuestSiteUntilAuth };
};
